import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { CommonService } from '../common.service';
import { APP_PLAN_TIERS_NAME, FREEMIUM_TIER_DISABLED_URLS } from '@app/shared';

@Injectable({ providedIn: 'root' })
export class AppGuard  {

  constructor(private readonly _router: Router, private readonly _commonService: CommonService) { }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree | Promise<boolean | UrlTree> | Observable<boolean | UrlTree> {

    const envData: any = environment;
    let restrictedRoutes: string[] = envData['restrictedRoutes'] || [];
    
    if (this._commonService.currentAccountLimitsDataAsValue?.plan == APP_PLAN_TIERS_NAME.FREE) {
      restrictedRoutes = [...restrictedRoutes, ...FREEMIUM_TIER_DISABLED_URLS].filter(url => !!url?.trim()?.length);
    }

    if (restrictedRoutes?.length && restrictedRoutes.find(allowedR => state.url.includes(('home/'+allowedR)))) {
        this._router.navigate(['/not-found']);
        return false;
    }

    return true;

  }
}
